import React from 'react';
import { Card } from '@avila-tek/ui/src';
import { Title } from '../../../shared';
import { TChartFilters } from '../../../../models';
import Empty from '../Empty';
import ChartFilters from '../ChartFilters';
import LineChart from './LineChart';

interface LineChartContainerProps {
  data: JSON[];
  title: string;
  loading: boolean;
  lineChartFilters: TChartFilters;
  setLineChartFilters: React.Dispatch<React.SetStateAction<TChartFilters>>;
}

function LineChartContainer({
  data,
  title,
  loading,
  lineChartFilters,
  setLineChartFilters,
}: LineChartContainerProps) {
  return (
    <Card className="w-full p-4 px-6 ">
      <Title title={title} />
      <ChartFilters
        chartFilters={lineChartFilters}
        setChartFilters={setLineChartFilters}
        loading={false}
        timeOptions={['hour', 'day', 'month', 'year']}
      />
      {!loading ? (
        <LineChart data={data} timeScale={lineChartFilters?.timeScale} />
      ) : (
        <Empty />
      )}
    </Card>
  );
}

export default LineChartContainer;
